import { LOOK_LIMITS, normaliseLook } from './look.js';
import type { Look } from './look.js';

/** Chosen at sign-up; decides the look a new account starts with. */
export const GENDERS = ['male', 'female'] as const;
export type Gender = (typeof GENDERS)[number];

/**
 * Free styles each starting look draws from (indices into the client's style
 * tables). Skin tone and colours are random for both. Players can change any
 * of it in the wardrobe afterwards, so this is only where they start.
 */
export const STARTER_STYLES = {
  male: { hair: [0, 2, 5, 7], eyes: [0], bottom: [0, 1] },
  female: { hair: [1, 3, 4, 6], eyes: [1], bottom: [2] },
} as const satisfies Record<Gender, { hair: readonly number[]; eyes: readonly number[]; bottom: readonly number[] }>;

/** Natural hair colours a new account can start with. */
const STARTER_HAIR_COLORS = [0, 1, 2, 3, 4, 5, 7] as const;

/** `int(limit)` returns a whole number from 0 up to, but not including, `limit`. */
export function starterLook(gender: Gender, int: (limit: number) => number): Look {
  const styles = STARTER_STYLES[gender];
  const choose = (options: readonly number[]) => options[int(options.length)] ?? options[0] ?? 0;
  return normaliseLook({
    body: int(LOOK_LIMITS.body),
    eyes: choose(styles.eyes),
    hair: choose(styles.hair),
    // Index 6 is the pink dye: fun to pick later, but not every newcomer's start.
    hairColor: choose(STARTER_HAIR_COLORS),
    top: 0,
    topColor: int(8),
    bottom: choose(styles.bottom),
    bottomColor: int(8),
  });
}
